module.exports = __webpack_public_path__ + "assets/img/card-group-avatar.svg";